/* eslint-disable react/prop-types */
import { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import { formatDate } from "utils";
import { CompanyService } from "services/companyService";
import toast from "react-hot-toast";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import journalVoucher6Service from "services/journal-voucher-6";

const currentYear = String(new Date().getFullYear());
const currentMonth = String(new Date().getMonth() + 1);

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    return {
      id: item._id,
      unit: item.unit || "",
      month: item.month || "",
      year: item.year || "",
      createdAt: formatDate(item.createdAt),
      autoMapped: item.autoMapped,
      action: <ActionCell item={{ ...item, id: item._id }} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Đơn vị", accessor: "unit", width: "40%" },
    { Header: "Tháng", accessor: "month", width: "10%" },
    { Header: "Năm", accessor: "year", width: "10%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "20%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function JournalVoucher6() {
  const [companyId, setCompanyId] = useState("");
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [filters, setFilters] = useState({
    year: currentYear,
    month: currentMonth,
    accountCode: "",
    searchBy: "",
  });
  const [query, setQuery] = useState({
    year: currentYear,
    month: currentMonth,
    accountCode: "",
    searchBy: "",
    sortBy: "createdAt",
    sortType: "desc"
  });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    const init = async () => {
      try {
        const response = await CompanyService.getByAuth();
        const payload = response?.data || response || {};
        setCompanyId(payload?._id || "");
      } catch (error) {
        console.error("Lỗi lấy thông tin công ty:", error);
      }
    };
    init();
  }, []);

  const fetchData = useCallback(async () => {
    if (!companyId) return;
    try {
      setLoading(true);
      const response = await journalVoucher6Service.findAll({
        ...query,
        company: companyId,
        page: paginationData.page,
        limit: paginationData.size,
      });

      const { data, total } = response.data || response;
      setCheckCreate(true);
      setPaginationData((prev) => ({
        ...prev,
        count: total || 0,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(data || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Nhật ký Chứng từ số 6:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  }, [companyId, query, paginationData.page, paginationData.size]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSync = async () => {
    if (!companyId || !filters.year || !filters.month) {
      toast.error("Thiếu thông tin công ty, năm hoặc tháng");
      return;
    }
    try {
      setSyncing(true);
      await journalVoucher6Service.sync({
        company: companyId,
        year: filters.year,
        month: filters.month,
      });

      toast.success("Đồng bộ dữ liệu thành công!");
      setPaginationData((prev) => ({ ...prev, page: 1 }));
      setQuery((prev) => ({ ...prev, ...filters }));
    } catch (error) {
      console.error("Lỗi khi đồng bộ dữ liệu:", error);
      toast.error(error.response?.data?.message || "Đồng bộ dữ liệu thất bại!");
    } finally {
      setSyncing(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card sx={{ mt: 3 }}>
        <DataTable
          table={dataTable}
          loading={loading}
          paginationData={paginationData}
          setPaginationData={setPaginationData}
          query={query}
          setQuery={setQuery}
          filters={filters}
          setFilters={setFilters}
          onSync={handleSync}
          syncing={syncing}
          onFetchData={(newFilters) => {
            setQuery((prev) => ({ ...prev, ...newFilters }));
            setPaginationData((prev) => ({ ...prev, page: 1 }));
          }}
        />
      </Card>
    </DashboardLayout>
  );
}

export default JournalVoucher6;
